import { IRowNode, RowSelectionOptions } from "ag-grid-community";

import { RowSelectionMode } from "components/AgGrid/constants";

export function buildRowSelectionOptions(
  rowSelection: RowSelectionMode | undefined,
  rowsSelectable: boolean,
  isRowSelectable: ((node: IRowNode) => boolean) | undefined,
  enableClickSelection: boolean,
): RowSelectionOptions {
  const mode = rowSelection ?? RowSelectionMode.SINGLE;
  const isMultiple = mode === RowSelectionMode.MULTIPLE;

  return {
    // For multi-select: default click-to-select and group descendant selection.
    ...(isMultiple && {
      enableClickSelection,
      groupSelects: "descendants" as const,
    }),
    mode,
    // Checkboxes are controlled by rowsSelectable, not the caller.
    checkboxes: rowsSelectable,
    ...(isRowSelectable && { isRowSelectable }),
    ...(isMultiple &&
      rowsSelectable && {
        headerCheckbox: true,
        selectAll: "filtered" as const,
      }),
  };
}
